import React from 'react';
import { useAppName } from '../hooks/useAppName';
import { useAppPublisher } from '../hooks/useAppPublisher';

interface Props {
  sticky?: boolean
}

export const Footer: React.FC<Props> = ({ sticky }) => {
  const appName = useAppName();
  const publisher = useAppPublisher();

  return (
    <footer className={`${sticky && 'sticky bottom-0'} z-9 border-t border-gray-medium min-h-[64px] px-6 py-2.5 bg-white-dirty-lighter`}>
      <div className="flex flex-row px-3 py-2.5 justify-between">
        <h4 className="text-gray">
          ©
          {' '}
          {appName}
          {' '}
          {publisher}
        </h4>
        <div>
          <a href="/" className="text-gray-dark hover:text-blue">
            Compliance
          </a>
          <span className="px-4">
            &#8226;
          </span>
          <a href="/" className="text-gray-dark hover:text-blue">
            Data Privacy
          </a>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  sticky: false,
};
